// extracted by mini-css-extract-plugin
module.exports = {"button":"_6c97079b1b--button--_e_VL","icon":"_6c97079b1b--icon--zwZnn"};